import React, {Component} from 'react';
import {Route, Routes} from "react-router-dom";

import Survey from "./container/Survey";


class App extends Component {
  render() {
    return (
      <Routes>
        <Route exact path="/:par1/:guid" element={<Survey/>} />
        <Route exact path="/:par1/:guid/continue/:srId/:surveyResponseKey" element={<Survey/>}/>
        <Route exact path="/:par1/:guid/:subguid" element={<Survey/>}/>
        <Route exact path="/:par1/:guid/response/:pausedResponseId" element={<Survey/>}/>
      </Routes>
    );
  }
}

export default App;
